<template>
	<div class="about min-contain">
		<div class="about-main">
			<img src="../assets/about/1164759.png" alt="" srcset="" />
		</div>
		<div class="about-main">
			<img src="../assets/about/2164738.png" alt="" srcset="" />
		</div>
	</div>
</template>
<script>
export default {
	name: 'About',
	data() {
		return {};
	},
};
</script>

<style lang="less" scoped>
.about-main {
	height: 520px;
	width: 100%;
	display: flex;
	margin-bottom: 50px;
	margin-top: 100px;
	min-height: 50vh;
	img {
		width: 100%;
		// object-fit: cover;
	}
}
</style>
